/**
 * Reject after `ms`. Race it against a promise to bound how long that promise
 * may hang - used on boot-path auth reads so an unreachable backend or a stale
 * persisted session can never hold the app on a loading screen. On timeout the
 * caller falls open (treats the user as logged out) rather than waiting forever.
 */
export function rejectAfter(ms: number, message = 'timed out'): Promise<never> {
  return new Promise((_, reject) => {
    setTimeout(() => reject(new Error(message)), ms)
  })
}

/** Boot-path deadline: how long a single auth read may take before we fail open. */
export const AUTH_BOOT_TIMEOUT_MS = 8000
